import React from "react";
import CustomPagination from "../../components/Pagination/CustomPagination";
import SearchBox from "../../components/SearchBox/SearchBox";
import { useUserListingPage } from "../../customHooks/UserListingPage.js/useUserListingPage";
import UserListingItem from "../../components/UserListingItem/UserListingItem";

const UserListingPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hookProps = useUserListingPage(urlParams);
  const {
    userListingData,
    currentPage,
    itemsPerPage,
    setItemsPerPage,
    totalItemsCount,
    onPageChange,
    searchtextError,
    onSearchChange,
    placeholder,
    handleSubmit,
    responseMessage,
  } = hookProps;

  return (
    <div className="InnerContent formfeilds">
      <div className="row">
        <div className="col-12">
          <label className="Label " style={{ color: "#a75503" }}>
            Users
          </label>
        </div>
      </div>
      <hr></hr>
      <div className="formtag mt-5">
        <div className="row">
          <div className="col-10">
            <div className="searchuser d-flex ">
              <label htmlFor="Search" style={{ margin: "6px 10px 0px 0px" }}>
                Search User :
              </label>
              <SearchBox
                responseMessage={searchtextError}
                searchChange={onSearchChange}
                placeholder={placeholder}
              />
              <div className="showuser" style={{ marginLeft: "10px" }}>
                <button className="btn btn-secondary" onClick={handleSubmit}>
                  Show User
                </button>
              </div>
            </div>
          </div>

          {/* <div className="col-2">
            {totalItemsCount ? (
              <div className="text-right mr-3 mb-2">
                Results Per Page&nbsp;:&nbsp;
                <select onChange={(e) => setItemsPerPage(e.target.value)}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                </select>
              </div>
            ) : null}
          </div> */}
        </div>

        <div>
          <table
            className=" table table-striped table-bordered"
            cellSpacing="0"
            cellPadding="0"
            width="100%"
          >
            <thead className="thead-dark">
              <tr>
                <th width={"10%"}>Name</th>
                <th width={"10%"}>Phone Number</th>
                <th width={"15%"}>Email</th>
                <th width={"5%"}>Gender</th>
                <th width={"5%"}>Age</th>
                <th width={"15%"}>Education</th>
                <th width={"20%"}>Address</th>
                <th width={"10%"}>Pincode</th>
                <th width={"10%"}>View User Transaction</th>
              </tr>
            </thead>
            <tbody>
              {userListingData &&
              userListingData.usersData &&
              userListingData.usersData.length ? (
                <>
                  {userListingData.usersData.map((users, index) => (
                    <UserListingItem users={users} key={index} count={index} />
                  ))}
                </>
              ) : (
                <tr>
                  <td className="text-center" colSpan="9">
                    {responseMessage
                      ? responseMessage
                      : "Please Enter Valid User Name First"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* {itemsPerPage <= totalItemsCount ? (
          <div className="d-flex justify-content-center mt-5">
            <CustomPagination
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              itemsCount={totalItemsCount}
              onPageChange={onPageChange}
            />
          </div>
        ) : null} */}
      </div>
    </div>
  );
};

export default UserListingPage;
